import { twMerge } from 'tailwind-merge';

/**
 * The app's shared branded backdrop: a very faint 44px grid plus a soft
 * forest-green glow at the top, both radial-masked so they fade out before they
 * reach the bottom of the screen.
 *
 * Extracted from AuthShell (#2039) so the signed-out native landing and the
 * sign-in screen it leads to share one treatment instead of the landing reading
 * as a bare screen. Purely decorative: `aria-hidden` + `pointer-events-none`,
 * and the mask keeps it well under the content and the primary button.
 *
 * Absolutely positioned — the caller must be a positioned (`relative`) element,
 * and must render its own content above it (a `relative` wrapper is enough,
 * since this paints first in DOM order).
 *
 * Not to be confused with the command center's own green-tinted grid in
 * pages/(guarded)/admin/TodaysReleases.css, which is a separate variant.
 */
export function GridBackdrop({ className }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={twMerge('pointer-events-none absolute inset-0 overflow-hidden', className)}
    >
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            'linear-gradient(to right, rgba(127,127,127,0.09) 1px, transparent 1px), linear-gradient(to bottom, rgba(127,127,127,0.09) 1px, transparent 1px)',
          backgroundSize: '44px 44px',
          WebkitMaskImage:
            'radial-gradient(120% 90% at 50% 0%, #000 0%, rgba(0,0,0,0.4) 45%, transparent 78%)',
          maskImage:
            'radial-gradient(120% 90% at 50% 0%, #000 0%, rgba(0,0,0,0.4) 45%, transparent 78%)',
        }}
      />
      <div
        className="absolute inset-x-0 top-0 h-[420px]"
        style={{
          background:
            'radial-gradient(60% 70% at 50% -8%, rgba(21,115,74,0.18) 0%, rgba(21,115,74,0.08) 38%, transparent 72%)',
        }}
      />
    </div>
  );
}

export default GridBackdrop;
